<div class="row justify-content-between align-items-center journey-step-row journey-success-row">
    <!-- Right Column: Loan Confirmation Details -->
    <div class="col-lg-6 col-12 order-1 order-lg-2 right-form-col">
        <div class="assist-card-unified">
            <div class="row justify-content-center mt-3 mt-lg-4">
                <div class="col-9 col-sm-8 blue_box p-3 p-sm-4 text-center">
                    <h3 class="heading">🎉 Success! Your Loan is Booked​</h3>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-11 white_box p-4 success-content-box">
                    <div class="row mt-2 justify-content-center">
                        <div class="col-11 col-sm-10 text-center successDiv">
                            <p class="sub-heading">Your <b>Travel Now, Pay Later</b> loan has been successfully booked and
                                will be disbursed soon<span *ngIf="agentName"> to <b>{{ agentName }}</b></span>.</p>
                            <div class="success-content">
                                <p class="question">📌 What’s Next?</p>
                                <ol>
                                    <li>✅ Loan disbursal is in progress</li>
                                    <li>✅ You are all set for your trip<span *ngIf="destination"> to {{ destination }}</span>! ✈️</li>
                                </ol>
                            </div>
                            <div>
                                <h3 class="message">🎊 Pack your bags and have an amazing journey! 🌍✨</h3>
                            </div>
                            <button *ngIf="redirect && redirect.length > 0" (click)="goBack()" class="btn btn-warning mt-4">Go Back to
                                Partner's Site</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Left Column: Flight Plane Animation -->
    <div class="col-lg-6 col-12 order-2 order-lg-1 left-flight-col mt-4 mt-lg-0">
        <div class="flight-plane-wrapper">
            <div class="row justify-content-center">
                <div class="col-11 flight-plane-card">
                    <img src="../../../../assets/images/success.gif" class="success-plane-img" alt="Flight departure animation">
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>